module.exports = __webpack_public_path__ + "img/aqitai.c431293e.svg";